export default __webpack_public_path__ + "static/media/179.51f6e00b.jpg";